"use strict"

function reservationTimestamp(item) {
  const time = String((item && item.times) || "00:00")
    .split(",")[0]
    .trim()
  const [hours = 0, minutes = 0] = time.split(":").map(Number)
  const timestamp = new Date(
    Number(item && item.year),
    Number(item && item.month) - 1,
    Number(item && item.day),
    hours,
    minutes
  ).getTime()
  return Number.isFinite(timestamp) ? timestamp : 0
}

function photoAccessDeadlineTimestamp(item) {
  const year = Number(item && item.year)
  const month = Number(item && item.month)
  const day = Number(item && item.day)
  const reservationDate = new Date(year, month - 1, day)

  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day) ||
    reservationDate.getFullYear() !== year ||
    reservationDate.getMonth() !== month - 1 ||
    reservationDate.getDate() !== day
  ) {
    return 0
  }

  return new Date(year, month - 1, day + 7).getTime()
}

function isPhotoAccessExpired(item, now = Date.now()) {
  const deadline = photoAccessDeadlineTimestamp(item)
  return deadline > 0 && now >= deadline
}

function sortReservationsByProximity(items, now = Date.now()) {
  return [...(Array.isArray(items) ? items : [])].sort((left, right) => {
    const leftTimestamp = reservationTimestamp(left)
    const rightTimestamp = reservationTimestamp(right)
    const distanceDifference =
      Math.abs(leftTimestamp - now) - Math.abs(rightTimestamp - now)

    if (distanceDifference !== 0) return distanceDifference
    return rightTimestamp - leftTimestamp
  })
}

function isReservationUpcoming(item, now = Date.now()) {
  const timestamp = reservationTimestamp(item)
  return timestamp > 0 && timestamp > now
}

function findUpcomingReservation(items, now = Date.now(), isCanceled = () => false) {
  return (
    [...(Array.isArray(items) ? items : [])]
      .sort((left, right) => reservationTimestamp(left) - reservationTimestamp(right))
      .find((item) => !isCanceled(item) && isReservationUpcoming(item, now)) || null
  )
}

function conceptThumbnailUrl(value) {
  const image = String(value || "").trim()
  if (!image) return ""
  if (/^(?:https?:|data:|\/)/i.test(image)) return image
  return `/upload/concept/thumbnail_image/${image}`
}

function resolveReservationThumbnail({ item, concept, product, fallback }) {
  const conceptImage =
    concept &&
    (concept.pattern_1_image || concept.pattern1Image || concept.patternAImage)

  return (
    conceptThumbnailUrl(conceptImage) ||
    (item &&
      (item.conceptThumbnail ||
        item.concept_thumbnail ||
        item.thumbnail)) ||
    (product &&
      (product.thumbnail ||
        product.image ||
        product.mainImage ||
        product.main_image)) ||
    fallback ||
    ""
  )
}

function resolvePhotoAction({ item, serviceKey, now = Date.now() }) {
  const reservation = item || {}

  if (serviceKey === "makershot") {
    if (reservation.photoLookupStatus === "error") {
      return {
        disabled: true,
        labelKey: "button.photos-status-error",
        target: "none",
      }
    }
    if (isPhotoAccessExpired(reservation, now)) {
      return {
        disabled: true,
        labelKey: "page.mypage.shot-list.shot-image-select-date-over",
        target: "none",
      }
    }
    if (!reservation.hasMyShots) {
      return {
        disabled: true,
        labelKey: "button.unvisited",
        target: "none",
      }
    }
    return {
      disabled: false,
      labelKey: "button.check-original",
      target: reservation.qrcodeId ? "makershot-original" : "none",
    }
  }

  if (!serviceKey) {
    return {
      disabled: true,
      labelKey: "button.photos-status-error",
      target: "none",
    }
  }

  if (now < reservationTimestamp(reservation)) {
    return {
      disabled: true,
      labelKey: "button.unvisited",
      target: "none",
    }
  }

  if (isPhotoAccessExpired(reservation, now)) {
    return {
      disabled: true,
      labelKey: "page.mypage.shot-list.shot-image-select-date-over",
      target: "none",
    }
  }

  return {
    disabled: true,
    labelKey: "button.photos-preparing",
    target: "none",
  }
}

function resolvePhotoRoute({ action, item }) {
  if (!action || action.target !== "makershot-original" || !item || !item.qrcodeId) {
    return ""
  }
  return `/mypage/select?id=${item.qrcodeId}`
}

module.exports = {
  conceptThumbnailUrl,
  findUpcomingReservation,
  isPhotoAccessExpired,
  isReservationUpcoming,
  photoAccessDeadlineTimestamp,
  reservationTimestamp,
  resolvePhotoAction,
  resolvePhotoRoute,
  resolveReservationThumbnail,
  sortReservationsByProximity,
}
